import { render, staticRenderFns } from "./tabs-finish.vue?vue&type=template&id=720cbf84"
import script from "./tabs-finish.vue?vue&type=script&lang=js"
export * from "./tabs-finish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports